import React, {useState, useContext, useEffect} from "react"
import Link from "@amzn/meridian/link"
import Row from "@amzn/meridian/row";
import Tag from "@amzn/meridian/tag"
import Column from "@amzn/meridian/column"
import ControlGroup from "@amzn/meridian/control-group"
import RadioButton from "@amzn/meridian/radio-button"
import Box from "@amzn/meridian/box"
import {ReceiveFilterContext} from "./context/ReceiveFilterContext";
import {getCycleDataFromParent, getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {FormattedMessage, injectIntl} from "react-intl";
import {parseCapabilitiesResponse} from "../util/Util";
import {ConfigContext} from "../global/context/ConfigContext";
import {CAPABILITY} from "../util/Constants";

const ReceiveFilter = ({ intl }) => {
    const { cycles, dispatch } = useContext(ReceiveFilterContext)
    const [ filterState, setFilterState ] = useState(false);
    const {configDispatch, configViewModel} = useContext(ConfigContext);

    useEffect(() => {
        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = parseCapabilitiesResponse(capabilityResponse)
            configDispatch({type: 'GET_CAPABILITIES', capability});
            getCycleDataFromParent().then(cycleData => {
                dispatch({ type: 'INITIALIZE_CYCLES', cycleData});
            })
        })
    }, []);

    const toggleFilter = () => {
        setFilterState(!filterState);
    };

    if (CAPABILITY.AR_NEXT_GEN === configViewModel.capability) {
        return null
    }

    return (
        <Column>
            <Row width="100%" spacingInset="large large none large">
                <Box>
                    <Link href="" type="secondary" onClick={toggleFilter}>
                        <FormattedMessage id="receive.filter.title" defaultMessage="Options"/>
                    </Link>
                </Box>
                <Box>
                    <div className="filter-tag">
                        {cycles.selectedCycles.map(cycle => {
                            return <Tag key = {cycle} type="neutral">{cycle}</Tag>
                        })}
                    </div>
                </Box>
            </Row>
            {filterState ? <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                <ControlGroup
                    label={intl.formatMessage({id: 'receive.filter.cycle'})}
                    name="cycles"
                    onChange={(data) => dispatch({ type: 'SELECT_CYCLE', cycle: data })}
                    value={cycles.selectedCycles[0]}>
                    {cycles.allCycles.map(cycle => {
                        return <RadioButton value={cycle.cycleName}>{cycle.displayableName}</RadioButton>
                    })}
                </ControlGroup>
            </Row> : null}
        </Column>
    )
}

export default injectIntl(ReceiveFilter);


// WEBPACK FOOTER //
// ./src/components/receive/ReceiveFilter.js